import { TableSortLabel } from '@material-ui/core'
import React from 'react'
import { StyledTableCellHeader } from '../../components/hooks/BaseTableComponents'

function TableHeadCells({ headCells, order, orderBy, onRequestSort }) {
  const createSortHandler = property => event => {
    onRequestSort(event, property)
  }

  return (
    <>
      {headCells.map(headCell => (
        <StyledTableCellHeader
          key={headCell.id}
          sortDirection={orderBy === headCell.id ? order : false}
          align={headCell?.align || 'left'}
        >
          <TableSortLabel
            active={orderBy === headCell.id}
            direction={order}
            onClick={createSortHandler(headCell.id)}
          >
            {headCell.label}
          </TableSortLabel>
        </StyledTableCellHeader>
      ))}
    </>
  )
}

export default TableHeadCells
